import React, { Component, Fragment } from 'react'
import style from '../Stepper/stepper.style'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../../spinner/Spinner'
import { ButtonOutlined } from '../../app-button/button'
import { CheckSuccessIcon, AccountAlertIcon } from '../../app-icon/Icons'

class EcomAnalytics extends Component {
  state = {
    isError: false,
    isFetching: false,
    isReady: this.props.finish,
    errorsEcom: window.state.errorsEcom,
  }

  setup = status => {
    if (!status) {
      this.setState({
        isError: true,
      })
    }

    if (status) {
      this.setState({
        isReady: true,
      })

      if (this.state.errorsEcom && this.state.errorsEcom.length > 0) {
        location.reload()
      }
    }

    this.props.updateData(false, this.state.isReady)
    this.setState({
      isFetching: false,
    })
  }

  handleSetup = () => {
    this.setState({
      isFetching: true,
    })

    const url = '/ecom/enabled-ecom-analytics'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })
      .then(status)
      .then(json)
      .then(({ status }) => {
        this.timerId = setTimeout(() => this.setup(status), 500)
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  handleReset = () => {
    this.setState({
      isFetching: true,
    })

    const url = '/ecom/enabled-ecom-analytics-force'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })
      .then(status)
      .then(json)
      .then(({ status }) => {
        this.timerId = setTimeout(() => this.setup(status), 500)
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  componentWillUnmount() {
    clearTimeout(this.timerId)
  }

  render() {
    const { isFetching, isError, isReady } = this.state
    const { classes, errorsEcom } = this.props

    const error =
      isError || (errorsEcom && errorsEcom.length > 0) ? (
        <div className={classes.error}>
          <p>{`Мы не смогли включить эту настройку для вашего аккаунта автоматически. \n Сделайте это вручную и нажмите кнопку “Я включил настройку в GA!”.`}</p>

          <a
            href="/help/kak-vklyuchit-elektronnuyu-torgovlyu-ga"
            style={{
              fontSize: 16,
              lineHeight: 1.5,
              color: 'rgb(136, 102, 255)',
              textDecoration: 'underline',
            }}
          >
            Как включить Электронную торговлю в GA.
          </a>
          <div style={{ marginTop: 24 }}>
            <ButtonOutlined
              handleClick={this.handleSetup}
              style={{
                width: 282,
                height: 40,
                padding: 0,
                fontSize: 16,
              }}
              color="secondary"
              text={
                isFetching ? (
                  <Spinner stroke={'#8866ff'} />
                ) : (
                  'Я включил настройку в GA!'
                )
              }
            />
          </div>
        </div>
      ) : null

    const icon = isReady ? (
      <CheckSuccessIcon />
    ) : (
      <span
        style={{
          width: 6,
          height: 6,
          border: 'solid 1px rgba(136, 102, 255, 0.2)',
          display: 'block',
          borderRadius: '100%',
        }}
      />
    )

    const content = isReady ? (
      <div
        style={{
          fontSize: 16,
          fontWeight: 'bold',
          lineHeight: 1.5,
          color: 'rgb(136, 102, 255)',
        }}
      >
        Готово!
      </div>
    ) : (
      <Fragment>
        {error}
        {!isError && !(errorsEcom && errorsEcom.length > 0) ? (
          <ButtonOutlined
            handleClick={this.handleSetup}
            style={{
              width: 200,
              height: 40,
              padding: 0,
            }}
            color="secondary"
            text={isFetching ? <Spinner stroke={'#8866ff'} /> : 'Включить'}
          />
        ) : null}
      </Fragment>
    )

    return (
      <div className={classes.step}>
        {isReady ? null : (
          <div
            style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}
          >
            <AccountAlertIcon />
            <span className={classes.errorMessage}>
              Настройка “Электронной торговли” в GA отключена.
            </span>
          </div>
        )}
        <div className={classes.label}>
          {errorsEcom && errorsEcom.length > 0 ? null : (
            <span
              className={cx(classes.icon, {
                [classes.iconActive]: isReady,
              })}
            >
              {icon}
            </span>
          )}

          <span className={classes.title}>
            Включите настройку "Электронной торговли” в вашем аккаунте Google
            Analitics
          </span>
        </div>
        <div
          className={cx(classes.content, {
            [classes.contentActive]: isReady,
            [classes.contentError]: errorsEcom && errorsEcom.length > 0,
          })}
        >
          {content}
        </div>
      </div>
    )
  }
}

export default style(EcomAnalytics)
